import { useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { api, apiError } from "../api";
import { Layout } from "../components/Layout";
import { useSettings } from "../hooks";
import { captureUtm } from "../utm";

const SAATLER = ["10:00", "11:00", "12:00", "14:00", "15:00", "16:00", "17:00", "18:00"];

function gunler() {
  const out = [];
  const d = new Date();
  for (let i = 1; i <= 21; i++) {
    const x = new Date(d);
    x.setDate(d.getDate() + i);
    out.push(x);
  }
  return out;
}
const iso = (d) => d.toISOString().slice(0, 10);

export default function Randevu() {
  const s = useSettings();
  const { data: projects = [] } = useQuery({ queryKey: ["projects"], queryFn: async () => (await api.get("/projects")).data });
  const [adim, setAdim] = useState(1);
  const [proje, setProje] = useState("");
  const [tarih, setTarih] = useState("");
  const [saat, setSaat] = useState("");
  const [form, setForm] = useState({ ad: "", telefon: "", email: "", kvkk: false, website: "" });
  const [busy, setBusy] = useState({ full_days: [], taken: [] });
  const [hata, setHata] = useState("");
  const [sonuc, setSonuc] = useState(null);
  const set = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  useEffect(() => {
    if (!proje) return;
    api.get("/appointments/busy", { params: { proje } }).then((r) => setBusy(r.data)).catch(() => {});
  }, [proje]);

  const satiliSaatler = busy.taken.filter((t) => t.tarih === tarih).map((t) => t.saat);

  const gonder = async () => {
    setHata("");
    if (!/^[+]?[0-9\s]{10,}$/.test(form.telefon)) return setHata("Geçerli bir telefon numarası girin (ülke koduyla).");
    if (!form.kvkk) return setHata("KVKK onayı gereklidir.");
    try {
      const r = await api.post("/appointments", { proje, tarih, saat, ...form, utm: captureUtm() });
      setSonuc(r.data);
      setAdim(5);
    } catch (err) { setHata(apiError(err)); }
  };

  const icsIndir = () => {
    const blob = new Blob([sonuc.ics], { type: "text/calendar" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url; a.download = "ozalp-randevu.ics"; a.click();
    URL.revokeObjectURL(url);
  };

  const adimlar = ["Proje", "Tarih", "Saat", "İletişim", "Onay"];

  return (
    <Layout mesaj="Randevu almak istiyorum">
      <section className="sayfa-basi">
        <div className="veri bel">Randevu</div>
        <h1 className="h-dev" style={{ margin: "14px 0 30px" }}>Satış ofisi randevusu</h1>
        <div className="adimlar">
          {adimlar.map((a, i) => (
            <span key={a} className={`adim ${adim === i + 1 ? "aktif" : ""}`}>{i + 1}. {a}</span>
          ))}
        </div>

        {adim === 1 && (
          <div style={{ maxWidth: 520 }} data-testid="randevu-adim-proje">
            <label className="veri" style={{ display: "block", marginBottom: 10 }}>Proje seçin</label>
            <div className="proje-izgara" style={{ gridTemplateColumns: "1fr" }}>
              {projects.map((p) => (
                <button key={p.id} className="a-btn hayalet" style={{ justifyContent: "flex-start", padding: 16 }} onClick={() => { setProje(p.name); setAdim(2); }} data-testid={`randevu-proje-${p.slug}`}>
                  {p.name} — {p.location}
                </button>
              ))}
            </div>
          </div>
        )}

        {adim === 2 && (
          <div data-testid="randevu-adim-tarih">
            <p className="veri" style={{ marginBottom: 12 }}>{proje} · Tarih seçin (dolu ve Pazar günleri kapalı)</p>
            <div className="gun-izgara" style={{ maxWidth: 620 }}>
              {gunler().map((d) => {
                const key = iso(d);
                const kapali = d.getDay() === 0 || busy.full_days.includes(key);
                return (
                  <button key={key} disabled={kapali} className={tarih === key ? "sec" : ""} onClick={() => { setTarih(key); setAdim(3); }} data-testid={`randevu-gun-${key}`}>
                    {d.getDate()}.{d.getMonth() + 1}
                  </button>
                );
              })}
            </div>
            <button className="a-btn hayalet kucuk" style={{ marginTop: 18 }} onClick={() => setAdim(1)}>← Geri</button>
          </div>
        )}

        {adim === 3 && (
          <div data-testid="randevu-adim-saat">
            <p className="veri" style={{ marginBottom: 12 }}>{tarih} · Saat seçin</p>
            <div className="gun-izgara" style={{ maxWidth: 520 }}>
              {SAATLER.map((h) => (
                <button key={h} disabled={satiliSaatler.includes(h)} className={saat === h ? "sec" : ""} onClick={() => { setSaat(h); setAdim(4); }} data-testid={`randevu-saat-${h}`}>{h}</button>
              ))}
            </div>
            <button className="a-btn hayalet kucuk" style={{ marginTop: 18 }} onClick={() => setAdim(2)}>← Geri</button>
          </div>
        )}

        {adim === 4 && (
          <form className="form" onSubmit={(e) => { e.preventDefault(); gonder(); }} data-testid="randevu-adim-iletisim">
            <p className="veri">{proje} · {tarih} · {saat}</p>
            <input className="honeypot" tabIndex={-1} value={form.website} onChange={(e) => set("website", e.target.value)} aria-hidden />
            <div><label>Ad Soyad</label><input required value={form.ad} onChange={(e) => set("ad", e.target.value)} data-testid="randevu-ad" /></div>
            <div><label>Telefon (ülke koduyla)</label><input required placeholder="+90 5xx xxx xx xx" value={form.telefon} onChange={(e) => set("telefon", e.target.value)} data-testid="randevu-telefon" /></div>
            <div><label>E-posta</label><input type="email" value={form.email} onChange={(e) => set("email", e.target.value)} data-testid="randevu-email" /></div>
            <label className="kvkk"><input type="checkbox" checked={form.kvkk} onChange={(e) => set("kvkk", e.target.checked)} data-testid="randevu-kvkk" /><span>{s?.kvkk_text}</span></label>
            {hata && <div className="form-hata" data-testid="randevu-hata">{hata}</div>}
            <div className="a-satir">
              <button type="button" className="a-btn hayalet kucuk" onClick={() => setAdim(3)}>← Geri</button>
              <button className="dugme" data-testid="randevu-onayla">Randevuyu onayla</button>
            </div>
          </form>
        )}

        {adim === 5 && sonuc && (
          <div className="tesekkur" style={{ maxWidth: 520 }} data-testid="randevu-tesekkur">
            <h3 className="h-orta">Randevunuz oluşturuldu</h3>
            <p style={{ color: "var(--metin-2)", margin: "10px 0 20px" }}>{proje} · {tarih} · {saat}. Onay e-postası gönderildi (demo ortamında e-posta mocklanmıştır).</p>
            <button className="dugme" onClick={icsIndir} data-testid="randevu-ics">Takvime ekle (.ics)</button>
          </div>
        )}
      </section>
    </Layout>
  );
}
